export default __webpack_public_path__ + "static/media/statusNew.ad6deabf.png";